module.exports = __webpack_public_path__ + "static/media/Pin_Icon.d84aedc4.svg";